var _i = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function bi(e) {
  return e;
}
function Y(e, t, r, n, s, i, o, c, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return s(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return i(s(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return o(i(s(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return c(o(i(s(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return u(c(o(i(s(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function y(e, t, r, n, s, i, o, c, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return s(n(r(t(e))));
    case 6:
      return i(s(n(r(t(e)))));
    case 7:
      return o(i(s(n(r(t(e))))));
    case 8:
      return c(o(i(s(n(r(t(e)))))));
    case 9:
      return u(c(o(i(s(n(r(t(e))))))));
    default: {
      for (var l = arguments[0], f = 1; f < arguments.length; f++)
        l = arguments[f](l);
      return l;
    }
  }
}
var Ti = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(s) {
      return t.apply(void 0, _i([s], n, !1));
    };
  };
}, $i = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Ai = function(e) {
  return $i(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, ia = function(e) {
  return e._tag === "Some";
}, oa = { _tag: "None" }, ca = function(e) {
  return { _tag: "Some", value: e };
}, Si = function(e) {
  return e._tag === "Left";
}, Ei = function(e) {
  return e._tag === "Right";
}, wi = function(e) {
  return { _tag: "Left", left: e };
}, xi = function(e) {
  return { _tag: "Right", right: e };
}, ki = function(e) {
  return [e];
}, Ri = [], ji = Object.prototype.hasOwnProperty, Ci = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, s) {
        return e.concat(n, s);
      }, t);
    };
  };
}, Oi = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var s in e)
        ji.call(e, s) && (n[s] = e[s].concat(t[s], r[s]));
      return n;
    }
  };
}, cr = function() {
  return { concat: bi };
}, Ii = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, Mi = Ci, dn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Ni = Ri, Vi = function(e, t) {
  return e < 0 || e >= t.length;
}, Pi = function(e) {
  return function(t) {
    return dn(dn([], t, !0), [e], !1);
  };
}, Di = Pi, Li = ki, Q = {
  equals: function(e, t) {
    return e === t;
  }
}, Hi = {
  concat: function(e, t) {
    return e + t;
  }
}, Ui = "", kr = {
  concat: Hi.concat,
  empty: Ui
};
Q.equals;
var ua = function(e) {
  return e.trim();
}, la = function(e) {
  return e.length === 0;
}, bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function da(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Zi() {
  this.__data__ = [], this.size = 0;
}
var qi = Zi;
function Bi(e, t) {
  return e === t || e !== e && t !== t;
}
var Rr = Bi, Gi = Rr;
function zi(e, t) {
  for (var r = e.length; r--; )
    if (Gi(e[r][0], t))
      return r;
  return -1;
}
var Lt = zi, Fi = Lt, Ki = Array.prototype, Wi = Ki.splice;
function Qi(e) {
  var t = this.__data__, r = Fi(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Wi.call(t, r, 1), --this.size, !0;
}
var Ji = Qi, Yi = Lt;
function Xi(e) {
  var t = this.__data__, r = Yi(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var eo = Xi, to = Lt;
function ro(e) {
  return to(this.__data__, e) > -1;
}
var no = ro, ao = Lt;
function so(e, t) {
  var r = this.__data__, n = ao(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var io = so, oo = qi, co = Ji, uo = eo, lo = no, fo = io;
function Ie(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ie.prototype.clear = oo;
Ie.prototype.delete = co;
Ie.prototype.get = uo;
Ie.prototype.has = lo;
Ie.prototype.set = fo;
var Ht = Ie, po = Ht;
function ho() {
  this.__data__ = new po(), this.size = 0;
}
var vo = ho;
function mo(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var go = mo;
function yo(e) {
  return this.__data__.get(e);
}
var _o = yo;
function bo(e) {
  return this.__data__.has(e);
}
var To = bo, $o = typeof bt == "object" && bt && bt.Object === Object && bt, fa = $o, Ao = fa, So = typeof self == "object" && self && self.Object === Object && self, Eo = Ao || So || Function("return this")(), F = Eo, wo = F, xo = wo.Symbol, Ut = xo, fn = Ut, pa = Object.prototype, ko = pa.hasOwnProperty, Ro = pa.toString, He = fn ? fn.toStringTag : void 0;
function jo(e) {
  var t = ko.call(e, He), r = e[He];
  try {
    e[He] = void 0;
    var n = !0;
  } catch {
  }
  var s = Ro.call(e);
  return n && (t ? e[He] = r : delete e[He]), s;
}
var Co = jo, Oo = Object.prototype, Io = Oo.toString;
function Mo(e) {
  return Io.call(e);
}
var No = Mo, pn = Ut, Vo = Co, Po = No, Do = "[object Null]", Lo = "[object Undefined]", hn = pn ? pn.toStringTag : void 0;
function Ho(e) {
  return e == null ? e === void 0 ? Lo : Do : hn && hn in Object(e) ? Vo(e) : Po(e);
}
var Zt = Ho;
function Uo(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var at = Uo, Zo = Zt, qo = at, Bo = "[object AsyncFunction]", Go = "[object Function]", zo = "[object GeneratorFunction]", Fo = "[object Proxy]";
function Ko(e) {
  if (!qo(e))
    return !1;
  var t = Zo(e);
  return t == Go || t == zo || t == Bo || t == Fo;
}
var ha = Ko, Wo = F, Qo = Wo["__core-js_shared__"], Jo = Qo, ur = Jo, vn = function() {
  var e = /[^.]+$/.exec(ur && ur.keys && ur.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Yo(e) {
  return !!vn && vn in e;
}
var Xo = Yo, ec = Function.prototype, tc = ec.toString;
function rc(e) {
  if (e != null) {
    try {
      return tc.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var va = rc, nc = ha, ac = Xo, sc = at, ic = va, oc = /[\\^$.*+?()[\]{}|]/g, cc = /^\[object .+?Constructor\]$/, uc = Function.prototype, lc = Object.prototype, dc = uc.toString, fc = lc.hasOwnProperty, pc = RegExp(
  "^" + dc.call(fc).replace(oc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function hc(e) {
  if (!sc(e) || ac(e))
    return !1;
  var t = nc(e) ? pc : cc;
  return t.test(ic(e));
}
var vc = hc;
function mc(e, t) {
  return e == null ? void 0 : e[t];
}
var gc = mc, yc = vc, _c = gc;
function bc(e, t) {
  var r = _c(e, t);
  return yc(r) ? r : void 0;
}
var ve = bc, Tc = ve, $c = F, Ac = Tc($c, "Map"), jr = Ac, Sc = ve, Ec = Sc(Object, "create"), qt = Ec, mn = qt;
function wc() {
  this.__data__ = mn ? mn(null) : {}, this.size = 0;
}
var xc = wc;
function kc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Rc = kc, jc = qt, Cc = "__lodash_hash_undefined__", Oc = Object.prototype, Ic = Oc.hasOwnProperty;
function Mc(e) {
  var t = this.__data__;
  if (jc) {
    var r = t[e];
    return r === Cc ? void 0 : r;
  }
  return Ic.call(t, e) ? t[e] : void 0;
}
var Nc = Mc, Vc = qt, Pc = Object.prototype, Dc = Pc.hasOwnProperty;
function Lc(e) {
  var t = this.__data__;
  return Vc ? t[e] !== void 0 : Dc.call(t, e);
}
var Hc = Lc, Uc = qt, Zc = "__lodash_hash_undefined__";
function qc(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Uc && t === void 0 ? Zc : t, this;
}
var Bc = qc, Gc = xc, zc = Rc, Fc = Nc, Kc = Hc, Wc = Bc;
function Me(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Me.prototype.clear = Gc;
Me.prototype.delete = zc;
Me.prototype.get = Fc;
Me.prototype.has = Kc;
Me.prototype.set = Wc;
var Qc = Me, gn = Qc, Jc = Ht, Yc = jr;
function Xc() {
  this.size = 0, this.__data__ = {
    hash: new gn(),
    map: new (Yc || Jc)(),
    string: new gn()
  };
}
var eu = Xc;
function tu(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var ru = tu, nu = ru;
function au(e, t) {
  var r = e.__data__;
  return nu(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Bt = au, su = Bt;
function iu(e) {
  var t = su(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var ou = iu, cu = Bt;
function uu(e) {
  return cu(this, e).get(e);
}
var lu = uu, du = Bt;
function fu(e) {
  return du(this, e).has(e);
}
var pu = fu, hu = Bt;
function vu(e, t) {
  var r = hu(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var mu = vu, gu = eu, yu = ou, _u = lu, bu = pu, Tu = mu;
function Ne(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ne.prototype.clear = gu;
Ne.prototype.delete = yu;
Ne.prototype.get = _u;
Ne.prototype.has = bu;
Ne.prototype.set = Tu;
var ma = Ne, $u = Ht, Au = jr, Su = ma, Eu = 200;
function wu(e, t) {
  var r = this.__data__;
  if (r instanceof $u) {
    var n = r.__data__;
    if (!Au || n.length < Eu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Su(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var xu = wu, ku = Ht, Ru = vo, ju = go, Cu = _o, Ou = To, Iu = xu;
function Ve(e) {
  var t = this.__data__ = new ku(e);
  this.size = t.size;
}
Ve.prototype.clear = Ru;
Ve.prototype.delete = ju;
Ve.prototype.get = Cu;
Ve.prototype.has = Ou;
Ve.prototype.set = Iu;
var ga = Ve;
function Mu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var Nu = Mu, Vu = ve, Pu = function() {
  try {
    var e = Vu(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Du = Pu, yn = Du;
function Lu(e, t, r) {
  t == "__proto__" && yn ? yn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var ya = Lu, Hu = ya, Uu = Rr, Zu = Object.prototype, qu = Zu.hasOwnProperty;
function Bu(e, t, r) {
  var n = e[t];
  (!(qu.call(e, t) && Uu(n, r)) || r === void 0 && !(t in e)) && Hu(e, t, r);
}
var _a = Bu, Gu = _a, zu = ya;
function Fu(e, t, r, n) {
  var s = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var c = t[i], u = n ? n(r[c], e[c], c, r, e) : void 0;
    u === void 0 && (u = e[c]), s ? zu(r, c, u) : Gu(r, c, u);
  }
  return r;
}
var Gt = Fu;
function Ku(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Wu = Ku;
function Qu(e) {
  return e != null && typeof e == "object";
}
var Pe = Qu, Ju = Zt, Yu = Pe, Xu = "[object Arguments]";
function el(e) {
  return Yu(e) && Ju(e) == Xu;
}
var tl = el, _n = tl, rl = Pe, ba = Object.prototype, nl = ba.hasOwnProperty, al = ba.propertyIsEnumerable, sl = _n(/* @__PURE__ */ function() {
  return arguments;
}()) ? _n : function(e) {
  return rl(e) && nl.call(e, "callee") && !al.call(e, "callee");
}, il = sl, ol = Array.isArray, zt = ol, St = { exports: {} };
function cl() {
  return !1;
}
var ul = cl;
St.exports;
(function(e, t) {
  var r = F, n = ul, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, o = i && i.exports === s, c = o ? r.Buffer : void 0, u = c ? c.isBuffer : void 0, l = u || n;
  e.exports = l;
})(St, St.exports);
var Cr = St.exports, ll = 9007199254740991, dl = /^(?:0|[1-9]\d*)$/;
function fl(e, t) {
  var r = typeof e;
  return t = t ?? ll, !!t && (r == "number" || r != "symbol" && dl.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var pl = fl, hl = 9007199254740991;
function vl(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= hl;
}
var Ta = vl, ml = Zt, gl = Ta, yl = Pe, _l = "[object Arguments]", bl = "[object Array]", Tl = "[object Boolean]", $l = "[object Date]", Al = "[object Error]", Sl = "[object Function]", El = "[object Map]", wl = "[object Number]", xl = "[object Object]", kl = "[object RegExp]", Rl = "[object Set]", jl = "[object String]", Cl = "[object WeakMap]", Ol = "[object ArrayBuffer]", Il = "[object DataView]", Ml = "[object Float32Array]", Nl = "[object Float64Array]", Vl = "[object Int8Array]", Pl = "[object Int16Array]", Dl = "[object Int32Array]", Ll = "[object Uint8Array]", Hl = "[object Uint8ClampedArray]", Ul = "[object Uint16Array]", Zl = "[object Uint32Array]", w = {};
w[Ml] = w[Nl] = w[Vl] = w[Pl] = w[Dl] = w[Ll] = w[Hl] = w[Ul] = w[Zl] = !0;
w[_l] = w[bl] = w[Ol] = w[Tl] = w[Il] = w[$l] = w[Al] = w[Sl] = w[El] = w[wl] = w[xl] = w[kl] = w[Rl] = w[jl] = w[Cl] = !1;
function ql(e) {
  return yl(e) && gl(e.length) && !!w[ml(e)];
}
var Bl = ql;
function Gl(e) {
  return function(t) {
    return e(t);
  };
}
var Or = Gl, Et = { exports: {} };
Et.exports;
(function(e, t) {
  var r = fa, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, i = s && s.exports === n, o = i && r.process, c = function() {
    try {
      var u = s && s.require && s.require("util").types;
      return u || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(Et, Et.exports);
var Ir = Et.exports, zl = Bl, Fl = Or, bn = Ir, Tn = bn && bn.isTypedArray, Kl = Tn ? Fl(Tn) : zl, $a = Kl, Wl = Wu, Ql = il, Jl = zt, Yl = Cr, Xl = pl, ed = $a, td = Object.prototype, rd = td.hasOwnProperty;
function nd(e, t) {
  var r = Jl(e), n = !r && Ql(e), s = !r && !n && Yl(e), i = !r && !n && !s && ed(e), o = r || n || s || i, c = o ? Wl(e.length, String) : [], u = c.length;
  for (var l in e)
    (t || rd.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Xl(l, u))) && c.push(l);
  return c;
}
var Aa = nd, ad = Object.prototype;
function sd(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || ad;
  return e === r;
}
var Mr = sd;
function id(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Sa = id, od = Sa, cd = od(Object.keys, Object), ud = cd, ld = Mr, dd = ud, fd = Object.prototype, pd = fd.hasOwnProperty;
function hd(e) {
  if (!ld(e))
    return dd(e);
  var t = [];
  for (var r in Object(e))
    pd.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var vd = hd, md = ha, gd = Ta;
function yd(e) {
  return e != null && gd(e.length) && !md(e);
}
var Ea = yd, _d = Aa, bd = vd, Td = Ea;
function $d(e) {
  return Td(e) ? _d(e) : bd(e);
}
var Nr = $d, Ad = Gt, Sd = Nr;
function Ed(e, t) {
  return e && Ad(t, Sd(t), e);
}
var wd = Ed;
function xd(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var kd = xd, Rd = at, jd = Mr, Cd = kd, Od = Object.prototype, Id = Od.hasOwnProperty;
function Md(e) {
  if (!Rd(e))
    return Cd(e);
  var t = jd(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Id.call(e, n)) || r.push(n);
  return r;
}
var Nd = Md, Vd = Aa, Pd = Nd, Dd = Ea;
function Ld(e) {
  return Dd(e) ? Vd(e, !0) : Pd(e);
}
var Vr = Ld, Hd = Gt, Ud = Vr;
function Zd(e, t) {
  return e && Hd(t, Ud(t), e);
}
var qd = Zd, wt = { exports: {} };
wt.exports;
(function(e, t) {
  var r = F, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, i = s && s.exports === n, o = i ? r.Buffer : void 0, c = o ? o.allocUnsafe : void 0;
  function u(l, f) {
    if (f)
      return l.slice();
    var _ = l.length, A = c ? c(_) : new l.constructor(_);
    return l.copy(A), A;
  }
  e.exports = u;
})(wt, wt.exports);
var Bd = wt.exports;
function Gd(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var zd = Gd;
function Fd(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, s = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[s++] = o);
  }
  return i;
}
var Kd = Fd;
function Wd() {
  return [];
}
var wa = Wd, Qd = Kd, Jd = wa, Yd = Object.prototype, Xd = Yd.propertyIsEnumerable, $n = Object.getOwnPropertySymbols, ef = $n ? function(e) {
  return e == null ? [] : (e = Object(e), Qd($n(e), function(t) {
    return Xd.call(e, t);
  }));
} : Jd, Pr = ef, tf = Gt, rf = Pr;
function nf(e, t) {
  return tf(e, rf(e), t);
}
var af = nf;
function sf(e, t) {
  for (var r = -1, n = t.length, s = e.length; ++r < n; )
    e[s + r] = t[r];
  return e;
}
var xa = sf, of = Sa, cf = of(Object.getPrototypeOf, Object), ka = cf, uf = xa, lf = ka, df = Pr, ff = wa, pf = Object.getOwnPropertySymbols, hf = pf ? function(e) {
  for (var t = []; e; )
    uf(t, df(e)), e = lf(e);
  return t;
} : ff, Ra = hf, vf = Gt, mf = Ra;
function gf(e, t) {
  return vf(e, mf(e), t);
}
var yf = gf, _f = xa, bf = zt;
function Tf(e, t, r) {
  var n = t(e);
  return bf(e) ? n : _f(n, r(e));
}
var ja = Tf, $f = ja, Af = Pr, Sf = Nr;
function Ef(e) {
  return $f(e, Sf, Af);
}
var Ca = Ef, wf = ja, xf = Ra, kf = Vr;
function Rf(e) {
  return wf(e, kf, xf);
}
var jf = Rf, Cf = ve, Of = F, If = Cf(Of, "DataView"), Mf = If, Nf = ve, Vf = F, Pf = Nf(Vf, "Promise"), Df = Pf, Lf = ve, Hf = F, Uf = Lf(Hf, "Set"), Zf = Uf, qf = ve, Bf = F, Gf = qf(Bf, "WeakMap"), zf = Gf, vr = Mf, mr = jr, gr = Df, yr = Zf, _r = zf, Oa = Zt, De = va, An = "[object Map]", Ff = "[object Object]", Sn = "[object Promise]", En = "[object Set]", wn = "[object WeakMap]", xn = "[object DataView]", Kf = De(vr), Wf = De(mr), Qf = De(gr), Jf = De(yr), Yf = De(_r), de = Oa;
(vr && de(new vr(new ArrayBuffer(1))) != xn || mr && de(new mr()) != An || gr && de(gr.resolve()) != Sn || yr && de(new yr()) != En || _r && de(new _r()) != wn) && (de = function(e) {
  var t = Oa(e), r = t == Ff ? e.constructor : void 0, n = r ? De(r) : "";
  if (n)
    switch (n) {
      case Kf:
        return xn;
      case Wf:
        return An;
      case Qf:
        return Sn;
      case Jf:
        return En;
      case Yf:
        return wn;
    }
  return t;
});
var Ft = de, Xf = Object.prototype, ep = Xf.hasOwnProperty;
function tp(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && ep.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var rp = tp, np = F, ap = np.Uint8Array, Ia = ap, kn = Ia;
function sp(e) {
  var t = new e.constructor(e.byteLength);
  return new kn(t).set(new kn(e)), t;
}
var Dr = sp, ip = Dr;
function op(e, t) {
  var r = t ? ip(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var cp = op, up = /\w*$/;
function lp(e) {
  var t = new e.constructor(e.source, up.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var dp = lp, Rn = Ut, jn = Rn ? Rn.prototype : void 0, Cn = jn ? jn.valueOf : void 0;
function fp(e) {
  return Cn ? Object(Cn.call(e)) : {};
}
var pp = fp, hp = Dr;
function vp(e, t) {
  var r = t ? hp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var mp = vp, gp = Dr, yp = cp, _p = dp, bp = pp, Tp = mp, $p = "[object Boolean]", Ap = "[object Date]", Sp = "[object Map]", Ep = "[object Number]", wp = "[object RegExp]", xp = "[object Set]", kp = "[object String]", Rp = "[object Symbol]", jp = "[object ArrayBuffer]", Cp = "[object DataView]", Op = "[object Float32Array]", Ip = "[object Float64Array]", Mp = "[object Int8Array]", Np = "[object Int16Array]", Vp = "[object Int32Array]", Pp = "[object Uint8Array]", Dp = "[object Uint8ClampedArray]", Lp = "[object Uint16Array]", Hp = "[object Uint32Array]";
function Up(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case jp:
      return gp(e);
    case $p:
    case Ap:
      return new n(+e);
    case Cp:
      return yp(e, r);
    case Op:
    case Ip:
    case Mp:
    case Np:
    case Vp:
    case Pp:
    case Dp:
    case Lp:
    case Hp:
      return Tp(e, r);
    case Sp:
      return new n();
    case Ep:
    case kp:
      return new n(e);
    case wp:
      return _p(e);
    case xp:
      return new n();
    case Rp:
      return bp(e);
  }
}
var Zp = Up, qp = at, On = Object.create, Bp = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!qp(t))
      return {};
    if (On)
      return On(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), Gp = Bp, zp = Gp, Fp = ka, Kp = Mr;
function Wp(e) {
  return typeof e.constructor == "function" && !Kp(e) ? zp(Fp(e)) : {};
}
var Qp = Wp, Jp = Ft, Yp = Pe, Xp = "[object Map]";
function eh(e) {
  return Yp(e) && Jp(e) == Xp;
}
var th = eh, rh = th, nh = Or, In = Ir, Mn = In && In.isMap, ah = Mn ? nh(Mn) : rh, sh = ah, ih = Ft, oh = Pe, ch = "[object Set]";
function uh(e) {
  return oh(e) && ih(e) == ch;
}
var lh = uh, dh = lh, fh = Or, Nn = Ir, Vn = Nn && Nn.isSet, ph = Vn ? fh(Vn) : dh, hh = ph, vh = ga, mh = Nu, gh = _a, yh = wd, _h = qd, bh = Bd, Th = zd, $h = af, Ah = yf, Sh = Ca, Eh = jf, wh = Ft, xh = rp, kh = Zp, Rh = Qp, jh = zt, Ch = Cr, Oh = sh, Ih = at, Mh = hh, Nh = Nr, Vh = Vr, Ph = 1, Dh = 2, Lh = 4, Ma = "[object Arguments]", Hh = "[object Array]", Uh = "[object Boolean]", Zh = "[object Date]", qh = "[object Error]", Na = "[object Function]", Bh = "[object GeneratorFunction]", Gh = "[object Map]", zh = "[object Number]", Va = "[object Object]", Fh = "[object RegExp]", Kh = "[object Set]", Wh = "[object String]", Qh = "[object Symbol]", Jh = "[object WeakMap]", Yh = "[object ArrayBuffer]", Xh = "[object DataView]", ev = "[object Float32Array]", tv = "[object Float64Array]", rv = "[object Int8Array]", nv = "[object Int16Array]", av = "[object Int32Array]", sv = "[object Uint8Array]", iv = "[object Uint8ClampedArray]", ov = "[object Uint16Array]", cv = "[object Uint32Array]", E = {};
E[Ma] = E[Hh] = E[Yh] = E[Xh] = E[Uh] = E[Zh] = E[ev] = E[tv] = E[rv] = E[nv] = E[av] = E[Gh] = E[zh] = E[Va] = E[Fh] = E[Kh] = E[Wh] = E[Qh] = E[sv] = E[iv] = E[ov] = E[cv] = !0;
E[qh] = E[Na] = E[Jh] = !1;
function At(e, t, r, n, s, i) {
  var o, c = t & Ph, u = t & Dh, l = t & Lh;
  if (r && (o = s ? r(e, n, s, i) : r(e)), o !== void 0)
    return o;
  if (!Ih(e))
    return e;
  var f = jh(e);
  if (f) {
    if (o = xh(e), !c)
      return Th(e, o);
  } else {
    var _ = wh(e), A = _ == Na || _ == Bh;
    if (Ch(e))
      return bh(e, c);
    if (_ == Va || _ == Ma || A && !s) {
      if (o = u || A ? {} : Rh(e), !c)
        return u ? Ah(e, _h(o, e)) : $h(e, yh(o, e));
    } else {
      if (!E[_])
        return s ? e : {};
      o = kh(e, _, c);
    }
  }
  i || (i = new vh());
  var j = i.get(e);
  if (j)
    return j;
  i.set(e, o), Mh(e) ? e.forEach(function(O) {
    o.add(At(O, t, r, O, e, i));
  }) : Oh(e) && e.forEach(function(O, V) {
    o.set(V, At(O, t, r, V, e, i));
  });
  var M = l ? u ? Eh : Sh : u ? Vh : Nh, D = f ? void 0 : M(e);
  return mh(D || e, function(O, V) {
    D && (V = O, O = e[V]), gh(o, V, At(O, t, r, V, e, i));
  }), o;
}
var uv = At, lv = uv, dv = 1, fv = 4;
function pv(e) {
  return lv(e, dv | fv);
}
var hv = pv;
const vv = /* @__PURE__ */ da(hv);
var $;
(function(e) {
  e.assertEqual = (s) => s;
  function t(s) {
  }
  e.assertIs = t;
  function r(s) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (s) => {
    const i = {};
    for (const o of s)
      i[o] = o;
    return i;
  }, e.getValidEnumValues = (s) => {
    const i = e.objectKeys(s).filter((c) => typeof s[s[c]] != "number"), o = {};
    for (const c of i)
      o[c] = s[c];
    return e.objectValues(o);
  }, e.objectValues = (s) => e.objectKeys(s).map(function(i) {
    return s[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const o in s)
      Object.prototype.hasOwnProperty.call(s, o) && i.push(o);
    return i;
  }, e.find = (s, i) => {
    for (const o of s)
      if (i(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})($ || ($ = {}));
var br;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(br || (br = {}));
const h = $.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), J = (e) => {
  switch (typeof e) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return isNaN(e) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(e) ? h.array : e === null ? h.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? h.promise : typeof Map < "u" && e instanceof Map ? h.map : typeof Set < "u" && e instanceof Set ? h.set : typeof Date < "u" && e instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, d = $.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), mv = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class L extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(s);
        else if (o.code === "invalid_return_type")
          s(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          s(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let c = n, u = 0;
          for (; u < o.path.length; ) {
            const l = o.path[u];
            u === o.path.length - 1 ? (c[l] = c[l] || { _errors: [] }, c[l]._errors.push(r(o))) : c[l] = c[l] || { _errors: [] }, c = c[l], u++;
          }
        }
    };
    return s(this), n;
  }
  static assert(t) {
    if (!(t instanceof L))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, $.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(t(s))) : n.push(t(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
L.create = (e) => new L(e);
const we = (e, t) => {
  let r;
  switch (e.code) {
    case d.invalid_type:
      e.received === h.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case d.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, $.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${$.joinValues(e.keys, ", ")}`;
      break;
    case d.invalid_union:
      r = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${$.joinValues(e.options)}`;
      break;
    case d.invalid_enum_value:
      r = `Invalid enum value. Expected ${$.joinValues(e.options)}, received '${e.received}'`;
      break;
    case d.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      r = "Invalid function return type";
      break;
    case d.invalid_date:
      r = "Invalid date";
      break;
    case d.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : $.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case d.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case d.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case d.custom:
      r = "Invalid input";
      break;
    case d.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case d.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, $.assertNever(e);
  }
  return { message: r };
};
let Pa = we;
function gv(e) {
  Pa = e;
}
function xt() {
  return Pa;
}
const kt = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: s } = e, i = [...r, ...s.path || []], o = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let c = "";
  const u = n.filter((l) => !!l).slice().reverse();
  for (const l of u)
    c = l(o, { data: t, defaultError: c }).message;
  return {
    ...s,
    path: i,
    message: c
  };
}, yv = [];
function p(e, t) {
  const r = xt(), n = kt({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      r,
      r === we ? void 0 : we
      // then global default map
    ].filter((s) => !!s)
  });
  e.common.issues.push(n);
}
class N {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return g;
      s.status === "dirty" && t.dirty(), n.push(s.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const s of r) {
      const i = await s.key, o = await s.value;
      n.push({
        key: i,
        value: o
      });
    }
    return N.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const s of r) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted")
        return g;
      i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || s.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const g = Object.freeze({
  status: "aborted"
}), Se = (e) => ({ status: "dirty", value: e }), P = (e) => ({ status: "valid", value: e }), Tr = (e) => e.status === "aborted", $r = (e) => e.status === "dirty", qe = (e) => e.status === "valid", Be = (e) => typeof Promise < "u" && e instanceof Promise;
function Rt(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function Da(e, t, r, n, s) {
  if (typeof t == "function" ? e !== t || !s : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
var Ue, Ze;
class B {
  constructor(t, r, n, s) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Pn = (e, t) => {
  if (qe(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new L(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function b(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: s } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: s } : { errorMap: (o, c) => {
    var u, l;
    const { message: f } = e;
    return o.code === "invalid_enum_value" ? { message: f ?? c.defaultError } : typeof c.data > "u" ? { message: (u = f ?? n) !== null && u !== void 0 ? u : c.defaultError } : o.code !== "invalid_type" ? { message: c.defaultError } : { message: (l = f ?? r) !== null && l !== void 0 ? l : c.defaultError };
  }, description: s };
}
class T {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return J(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: J(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new N(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: J(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Be(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: J(t)
    }, i = this._parseSync({ data: t, path: s.path, parent: s });
    return Pn(s, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: J(t)
    }, s = this._parse({ data: t, path: n.path, parent: n }), i = await (Be(s) ? s : Promise.resolve(s));
    return Pn(n, i);
  }
  refine(t, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, i) => {
      const o = t(s), c = () => i.addIssue({
        code: d.custom,
        ...n(s)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => u ? !0 : (c(), !1)) : o ? !0 : (c(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, s) => t(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(t) {
    return new Z({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return q.create(this, this._def);
  }
  nullable() {
    return re.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return U.create(this, this._def);
  }
  promise() {
    return ke.create(this, this._def);
  }
  or(t) {
    return Ke.create([this, t], this._def);
  }
  and(t) {
    return We.create(this, t, this._def);
  }
  transform(t) {
    return new Z({
      ...b(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new et({
      ...b(this._def),
      innerType: this,
      defaultValue: r,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new Lr({
      typeName: m.ZodBranded,
      type: this,
      ...b(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new tt({
      ...b(this._def),
      innerType: this,
      catchValue: r,
      typeName: m.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return st.create(this, t);
  }
  readonly() {
    return rt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const _v = /^c[^\s-]{8,}$/i, bv = /^[0-9a-z]+$/, Tv = /^[0-9A-HJKMNP-TV-Z]{26}$/, $v = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Av = /^[a-z0-9_-]{21}$/i, Sv = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Ev = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, wv = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let lr;
const xv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, kv = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Rv = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, La = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", jv = new RegExp(`^${La}$`);
function Ha(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function Cv(e) {
  return new RegExp(`^${Ha(e)}$`);
}
function Ua(e) {
  let t = `${La}T${Ha(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Ov(e, t) {
  return !!((t === "v4" || !t) && xv.test(e) || (t === "v6" || !t) && kv.test(e));
}
class H extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== h.string) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.string,
        received: i.parsedType
      }), g;
    }
    const n = new N();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (s = this._getOrReturnCtx(t, s), p(s, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (s = this._getOrReturnCtx(t, s), p(s, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = t.data.length > i.value, c = t.data.length < i.value;
        (o || c) && (s = this._getOrReturnCtx(t, s), o ? p(s, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : c && p(s, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        Ev.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "email",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        lr || (lr = new RegExp(wv, "u")), lr.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "emoji",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        $v.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "uuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        Av.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "nanoid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        _v.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "cuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        bv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "cuid2",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        Tv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "ulid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          s = this._getOrReturnCtx(t, s), p(s, {
            validation: "url",
            code: d.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "regex",
        code: d.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? Ua(i).test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? jv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? Cv(i).test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? Sv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "duration",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? Ov(t.data, i.version) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "ip",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? Rv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "base64",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : $.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((s) => t.test(s), {
      validation: r,
      code: d.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new H({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t == null ? void 0 : t.local) !== null && n !== void 0 ? n : !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...v.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
H.create = (e) => {
  var t;
  return new H({
    checks: [],
    typeName: m.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...b(e)
  });
};
function Iv(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, s = r > n ? r : n, i = parseInt(e.toFixed(s).replace(".", "")), o = parseInt(t.toFixed(s).replace(".", ""));
  return i % o / Math.pow(10, s);
}
class X extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== h.number) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.number,
        received: i.parsedType
      }), g;
    }
    let n;
    const s = new N();
    for (const i of this._def.checks)
      i.kind === "int" ? $.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? Iv(t.data, i.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_finite,
        message: i.message
      }), s.dirty()) : $.assertNever(i);
    return { status: s.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, s) {
    return new X({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new X({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && $.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
X.create = (e) => new X({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...b(e)
});
class ee extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== h.bigint) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.bigint,
        received: i.parsedType
      }), g;
    }
    let n;
    const s = new N();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : $.assertNever(i);
    return { status: s.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, s) {
    return new ee({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ee({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
ee.create = (e) => {
  var t;
  return new ee({
    checks: [],
    typeName: m.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...b(e)
  });
};
class Ge extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== h.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.boolean,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Ge.create = (e) => new Ge({
  typeName: m.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...b(e)
});
class pe extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== h.date) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.date,
        received: i.parsedType
      }), g;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_date
      }), g;
    }
    const n = new N();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : $.assertNever(i);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new pe({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
pe.create = (e) => new pe({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: m.ZodDate,
  ...b(e)
});
class jt extends T {
  _parse(t) {
    if (this._getType(t) !== h.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.symbol,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
jt.create = (e) => new jt({
  typeName: m.ZodSymbol,
  ...b(e)
});
class ze extends T {
  _parse(t) {
    if (this._getType(t) !== h.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.undefined,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
ze.create = (e) => new ze({
  typeName: m.ZodUndefined,
  ...b(e)
});
class Fe extends T {
  _parse(t) {
    if (this._getType(t) !== h.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.null,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Fe.create = (e) => new Fe({
  typeName: m.ZodNull,
  ...b(e)
});
class xe extends T {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
xe.create = (e) => new xe({
  typeName: m.ZodAny,
  ...b(e)
});
class fe extends T {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
fe.create = (e) => new fe({
  typeName: m.ZodUnknown,
  ...b(e)
});
class W extends T {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: d.invalid_type,
      expected: h.never,
      received: r.parsedType
    }), g;
  }
}
W.create = (e) => new W({
  typeName: m.ZodNever,
  ...b(e)
});
class Ct extends T {
  _parse(t) {
    if (this._getType(t) !== h.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.void,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Ct.create = (e) => new Ct({
  typeName: m.ZodVoid,
  ...b(e)
});
class U extends T {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), s = this._def;
    if (r.parsedType !== h.array)
      return p(r, {
        code: d.invalid_type,
        expected: h.array,
        received: r.parsedType
      }), g;
    if (s.exactLength !== null) {
      const o = r.data.length > s.exactLength.value, c = r.data.length < s.exactLength.value;
      (o || c) && (p(r, {
        code: o ? d.too_big : d.too_small,
        minimum: c ? s.exactLength.value : void 0,
        maximum: o ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (p(r, {
      code: d.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (p(r, {
      code: d.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, c) => s.type._parseAsync(new B(r, o, r.path, c)))).then((o) => N.mergeArray(n, o));
    const i = [...r.data].map((o, c) => s.type._parseSync(new B(r, o, r.path, c)));
    return N.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new U({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new U({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new U({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
U.create = (e, t) => new U({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ...b(t)
});
function Ae(e) {
  if (e instanceof x) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = q.create(Ae(n));
    }
    return new x({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof U ? new U({
    ...e._def,
    type: Ae(e.element)
  }) : e instanceof q ? q.create(Ae(e.unwrap())) : e instanceof re ? re.create(Ae(e.unwrap())) : e instanceof G ? G.create(e.items.map((t) => Ae(t))) : e;
}
class x extends T {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = $.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== h.object) {
      const l = this._getOrReturnCtx(t);
      return p(l, {
        code: d.invalid_type,
        expected: h.object,
        received: l.parsedType
      }), g;
    }
    const { status: n, ctx: s } = this._processInputParams(t), { shape: i, keys: o } = this._getCached(), c = [];
    if (!(this._def.catchall instanceof W && this._def.unknownKeys === "strip"))
      for (const l in s.data)
        o.includes(l) || c.push(l);
    const u = [];
    for (const l of o) {
      const f = i[l], _ = s.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: f._parse(new B(s, _, s.path, l)),
        alwaysSet: l in s.data
      });
    }
    if (this._def.catchall instanceof W) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const f of c)
          u.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: s.data[f] }
          });
      else if (l === "strict")
        c.length > 0 && (p(s, {
          code: d.unrecognized_keys,
          keys: c
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const f of c) {
        const _ = s.data[f];
        u.push({
          key: { status: "valid", value: f },
          value: l._parse(
            new B(s, _, s.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const f of u) {
        const _ = await f.key, A = await f.value;
        l.push({
          key: _,
          value: A,
          alwaysSet: f.alwaysSet
        });
      }
      return l;
    }).then((l) => N.mergeObjectSync(n, l)) : N.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new x({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i, o, c;
          const u = (o = (i = (s = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(s, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (c = v.errToObj(t).message) !== null && c !== void 0 ? c : u
          } : {
            message: u
          };
        }
      } : {}
    });
  }
  strip() {
    return new x({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new x({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new x({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new x({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return $.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Ae(this);
  }
  partial(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      t && !t[n] ? r[n] = s : r[n] = s.optional();
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof q; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Za($.objectKeys(this.shape));
  }
}
x.create = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
x.strictCreate = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strict",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
x.lazycreate = (e, t) => new x({
  shape: e,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
class Ke extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function s(i) {
      for (const c of i)
        if (c.result.status === "valid")
          return c.result;
      for (const c of i)
        if (c.result.status === "dirty")
          return r.common.issues.push(...c.ctx.common.issues), c.result;
      const o = i.map((c) => new L(c.ctx.common.issues));
      return p(r, {
        code: d.invalid_union,
        unionErrors: o
      }), g;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(s);
    {
      let i;
      const o = [];
      for (const u of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = u._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const c = o.map((u) => new L(u));
      return p(r, {
        code: d.invalid_union,
        unionErrors: c
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ke.create = (e, t) => new Ke({
  options: e,
  typeName: m.ZodUnion,
  ...b(t)
});
const K = (e) => e instanceof Je ? K(e.schema) : e instanceof Z ? K(e.innerType()) : e instanceof Ye ? [e.value] : e instanceof te ? e.options : e instanceof Xe ? $.objectValues(e.enum) : e instanceof et ? K(e._def.innerType) : e instanceof ze ? [void 0] : e instanceof Fe ? [null] : e instanceof q ? [void 0, ...K(e.unwrap())] : e instanceof re ? [null, ...K(e.unwrap())] : e instanceof Lr || e instanceof rt ? K(e.unwrap()) : e instanceof tt ? K(e._def.innerType) : [];
class Kt extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.object)
      return p(r, {
        code: d.invalid_type,
        expected: h.object,
        received: r.parsedType
      }), g;
    const n = this.discriminator, s = r.data[n], i = this.optionsMap.get(s);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), g);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = K(i.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const c of o) {
        if (s.has(c))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(c)}`);
        s.set(c, i);
      }
    }
    return new Kt({
      typeName: m.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: s,
      ...b(n)
    });
  }
}
function Ar(e, t) {
  const r = J(e), n = J(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === h.object && n === h.object) {
    const s = $.objectKeys(t), i = $.objectKeys(e).filter((c) => s.indexOf(c) !== -1), o = { ...e, ...t };
    for (const c of i) {
      const u = Ar(e[c], t[c]);
      if (!u.valid)
        return { valid: !1 };
      o[c] = u.data;
    }
    return { valid: !0, data: o };
  } else if (r === h.array && n === h.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const o = e[i], c = t[i], u = Ar(o, c);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return r === h.date && n === h.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class We extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = (i, o) => {
      if (Tr(i) || Tr(o))
        return g;
      const c = Ar(i.value, o.value);
      return c.valid ? (($r(i) || $r(o)) && r.dirty(), { status: r.value, value: c.data }) : (p(n, {
        code: d.invalid_intersection_types
      }), g);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
We.create = (e, t, r) => new We({
  left: e,
  right: t,
  typeName: m.ZodIntersection,
  ...b(r)
});
class G extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.array)
      return p(n, {
        code: d.invalid_type,
        expected: h.array,
        received: n.parsedType
      }), g;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, c) => {
      const u = this._def.items[c] || this._def.rest;
      return u ? u._parse(new B(n, o, n.path, c)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => N.mergeArray(r, o)) : N.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new G({
      ...this._def,
      rest: t
    });
  }
}
G.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new G({
    items: e,
    typeName: m.ZodTuple,
    rest: null,
    ...b(t)
  });
};
class Qe extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.object)
      return p(n, {
        code: d.invalid_type,
        expected: h.object,
        received: n.parsedType
      }), g;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const c in n.data)
      s.push({
        key: i._parse(new B(n, c, n.path, c)),
        value: o._parse(new B(n, n.data[c], n.path, c)),
        alwaysSet: c in n.data
      });
    return n.common.async ? N.mergeObjectAsync(r, s) : N.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof T ? new Qe({
      keyType: t,
      valueType: r,
      typeName: m.ZodRecord,
      ...b(n)
    }) : new Qe({
      keyType: H.create(),
      valueType: t,
      typeName: m.ZodRecord,
      ...b(r)
    });
  }
}
class Ot extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.map)
      return p(n, {
        code: d.invalid_type,
        expected: h.map,
        received: n.parsedType
      }), g;
    const s = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([c, u], l) => ({
      key: s._parse(new B(n, c, n.path, [l, "key"])),
      value: i._parse(new B(n, u, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const l = await u.key, f = await u.value;
          if (l.status === "aborted" || f.status === "aborted")
            return g;
          (l.status === "dirty" || f.status === "dirty") && r.dirty(), c.set(l.value, f.value);
        }
        return { status: r.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const u of o) {
        const l = u.key, f = u.value;
        if (l.status === "aborted" || f.status === "aborted")
          return g;
        (l.status === "dirty" || f.status === "dirty") && r.dirty(), c.set(l.value, f.value);
      }
      return { status: r.value, value: c };
    }
  }
}
Ot.create = (e, t, r) => new Ot({
  valueType: t,
  keyType: e,
  typeName: m.ZodMap,
  ...b(r)
});
class he extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.set)
      return p(n, {
        code: d.invalid_type,
        expected: h.set,
        received: n.parsedType
      }), g;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (p(n, {
      code: d.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (p(n, {
      code: d.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(u) {
      const l = /* @__PURE__ */ new Set();
      for (const f of u) {
        if (f.status === "aborted")
          return g;
        f.status === "dirty" && r.dirty(), l.add(f.value);
      }
      return { status: r.value, value: l };
    }
    const c = [...n.data.values()].map((u, l) => i._parse(new B(n, u, n.path, l)));
    return n.common.async ? Promise.all(c).then((u) => o(u)) : o(c);
  }
  min(t, r) {
    return new he({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new he({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
he.create = (e, t) => new he({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ...b(t)
});
class Ee extends T {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.function)
      return p(r, {
        code: d.invalid_type,
        expected: h.function,
        received: r.parsedType
      }), g;
    function n(c, u) {
      return kt({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          xt(),
          we
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function s(c, u) {
      return kt({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          xt(),
          we
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof ke) {
      const c = this;
      return P(async function(...u) {
        const l = new L([]), f = await c._def.args.parseAsync(u, i).catch((j) => {
          throw l.addIssue(n(u, j)), l;
        }), _ = await Reflect.apply(o, this, f);
        return await c._def.returns._def.type.parseAsync(_, i).catch((j) => {
          throw l.addIssue(s(_, j)), l;
        });
      });
    } else {
      const c = this;
      return P(function(...u) {
        const l = c._def.args.safeParse(u, i);
        if (!l.success)
          throw new L([n(u, l.error)]);
        const f = Reflect.apply(o, this, l.data), _ = c._def.returns.safeParse(f, i);
        if (!_.success)
          throw new L([s(f, _.error)]);
        return _.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Ee({
      ...this._def,
      args: G.create(t).rest(fe.create())
    });
  }
  returns(t) {
    return new Ee({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new Ee({
      args: t || G.create([]).rest(fe.create()),
      returns: r || fe.create(),
      typeName: m.ZodFunction,
      ...b(n)
    });
  }
}
class Je extends T {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Je.create = (e, t) => new Je({
  getter: e,
  typeName: m.ZodLazy,
  ...b(t)
});
class Ye extends T {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Ye.create = (e, t) => new Ye({
  value: e,
  typeName: m.ZodLiteral,
  ...b(t)
});
function Za(e, t) {
  return new te({
    values: e,
    typeName: m.ZodEnum,
    ...b(t)
  });
}
class te extends T {
  constructor() {
    super(...arguments), Ue.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: $.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (Rt(this, Ue) || Da(this, Ue, new Set(this._def.values)), !Rt(this, Ue).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), g;
    }
    return P(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return te.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return te.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Ue = /* @__PURE__ */ new WeakMap();
te.create = Za;
class Xe extends T {
  constructor() {
    super(...arguments), Ze.set(this, void 0);
  }
  _parse(t) {
    const r = $.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== h.string && n.parsedType !== h.number) {
      const s = $.objectValues(r);
      return p(n, {
        expected: $.joinValues(s),
        received: n.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (Rt(this, Ze) || Da(this, Ze, new Set($.getValidEnumValues(this._def.values))), !Rt(this, Ze).has(t.data)) {
      const s = $.objectValues(r);
      return p(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: s
      }), g;
    }
    return P(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ze = /* @__PURE__ */ new WeakMap();
Xe.create = (e, t) => new Xe({
  values: e,
  typeName: m.ZodNativeEnum,
  ...b(t)
});
class ke extends T {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.promise && r.common.async === !1)
      return p(r, {
        code: d.invalid_type,
        expected: h.promise,
        received: r.parsedType
      }), g;
    const n = r.parsedType === h.promise ? r.data : Promise.resolve(r.data);
    return P(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
ke.create = (e, t) => new ke({
  type: e,
  typeName: m.ZodPromise,
  ...b(t)
});
class Z extends T {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = this._def.effect || null, i = {
      addIssue: (o) => {
        p(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (c) => {
          if (r.value === "aborted")
            return g;
          const u = await this._def.schema._parseAsync({
            data: c,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? g : u.status === "dirty" || r.value === "dirty" ? Se(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return g;
        const c = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? g : c.status === "dirty" || r.value === "dirty" ? Se(c.value) : c;
      }
    }
    if (s.type === "refinement") {
      const o = (c) => {
        const u = s.refinement(c, i);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (n.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value), { status: r.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((c) => c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value).then(() => ({ status: r.value, value: c.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!qe(o))
          return o;
        const c = s.transform(o.value, i);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => qe(o) ? Promise.resolve(s.transform(o.value, i)).then((c) => ({ status: r.value, value: c })) : o);
    $.assertNever(s);
  }
}
Z.create = (e, t, r) => new Z({
  schema: e,
  typeName: m.ZodEffects,
  effect: t,
  ...b(r)
});
Z.createWithPreprocess = (e, t, r) => new Z({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: m.ZodEffects,
  ...b(r)
});
class q extends T {
  _parse(t) {
    return this._getType(t) === h.undefined ? P(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
q.create = (e, t) => new q({
  innerType: e,
  typeName: m.ZodOptional,
  ...b(t)
});
class re extends T {
  _parse(t) {
    return this._getType(t) === h.null ? P(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
re.create = (e, t) => new re({
  innerType: e,
  typeName: m.ZodNullable,
  ...b(t)
});
class et extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === h.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
et.create = (e, t) => new et({
  innerType: e,
  typeName: m.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...b(t)
});
class tt extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Be(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
tt.create = (e, t) => new tt({
  innerType: e,
  typeName: m.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...b(t)
});
class It extends T {
  _parse(t) {
    if (this._getType(t) !== h.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.nan,
        received: n.parsedType
      }), g;
    }
    return { status: "valid", value: t.data };
  }
}
It.create = (e) => new It({
  typeName: m.ZodNaN,
  ...b(e)
});
const Mv = Symbol("zod_brand");
class Lr extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class st extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? g : i.status === "dirty" ? (r.dirty(), Se(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? g : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new st({
      in: t,
      out: r,
      typeName: m.ZodPipeline
    });
  }
}
class rt extends T {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (s) => (qe(s) && (s.value = Object.freeze(s.value)), s);
    return Be(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rt.create = (e, t) => new rt({
  innerType: e,
  typeName: m.ZodReadonly,
  ...b(t)
});
function qa(e, t = {}, r) {
  return e ? xe.create().superRefine((n, s) => {
    var i, o;
    if (!e(n)) {
      const c = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, u = (o = (i = c.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, l = typeof c == "string" ? { message: c } : c;
      s.addIssue({ code: "custom", ...l, fatal: u });
    }
  }) : xe.create();
}
const Nv = {
  object: x.lazycreate
};
var m;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const Vv = (e, t = {
  message: `Input not instance of ${e.name}`
}) => qa((r) => r instanceof e, t), Ba = H.create, Ga = X.create, Pv = It.create, Dv = ee.create, za = Ge.create, Lv = pe.create, Hv = jt.create, Uv = ze.create, Zv = Fe.create, qv = xe.create, Bv = fe.create, Gv = W.create, zv = Ct.create, Fv = U.create, Kv = x.create, Wv = x.strictCreate, Qv = Ke.create, Jv = Kt.create, Yv = We.create, Xv = G.create, em = Qe.create, tm = Ot.create, rm = he.create, nm = Ee.create, am = Je.create, sm = Ye.create, im = te.create, om = Xe.create, cm = ke.create, Dn = Z.create, um = q.create, lm = re.create, dm = Z.createWithPreprocess, fm = st.create, pm = () => Ba().optional(), hm = () => Ga().optional(), vm = () => za().optional(), mm = {
  string: (e) => H.create({ ...e, coerce: !0 }),
  number: (e) => X.create({ ...e, coerce: !0 }),
  boolean: (e) => Ge.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => ee.create({ ...e, coerce: !0 }),
  date: (e) => pe.create({ ...e, coerce: !0 })
}, gm = g;
var a = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: we,
  setErrorMap: gv,
  getErrorMap: xt,
  makeIssue: kt,
  EMPTY_PATH: yv,
  addIssueToContext: p,
  ParseStatus: N,
  INVALID: g,
  DIRTY: Se,
  OK: P,
  isAborted: Tr,
  isDirty: $r,
  isValid: qe,
  isAsync: Be,
  get util() {
    return $;
  },
  get objectUtil() {
    return br;
  },
  ZodParsedType: h,
  getParsedType: J,
  ZodType: T,
  datetimeRegex: Ua,
  ZodString: H,
  ZodNumber: X,
  ZodBigInt: ee,
  ZodBoolean: Ge,
  ZodDate: pe,
  ZodSymbol: jt,
  ZodUndefined: ze,
  ZodNull: Fe,
  ZodAny: xe,
  ZodUnknown: fe,
  ZodNever: W,
  ZodVoid: Ct,
  ZodArray: U,
  ZodObject: x,
  ZodUnion: Ke,
  ZodDiscriminatedUnion: Kt,
  ZodIntersection: We,
  ZodTuple: G,
  ZodRecord: Qe,
  ZodMap: Ot,
  ZodSet: he,
  ZodFunction: Ee,
  ZodLazy: Je,
  ZodLiteral: Ye,
  ZodEnum: te,
  ZodNativeEnum: Xe,
  ZodPromise: ke,
  ZodEffects: Z,
  ZodTransformer: Z,
  ZodOptional: q,
  ZodNullable: re,
  ZodDefault: et,
  ZodCatch: tt,
  ZodNaN: It,
  BRAND: Mv,
  ZodBranded: Lr,
  ZodPipeline: st,
  ZodReadonly: rt,
  custom: qa,
  Schema: T,
  ZodSchema: T,
  late: Nv,
  get ZodFirstPartyTypeKind() {
    return m;
  },
  coerce: mm,
  any: qv,
  array: Fv,
  bigint: Dv,
  boolean: za,
  date: Lv,
  discriminatedUnion: Jv,
  effect: Dn,
  enum: im,
  function: nm,
  instanceof: Vv,
  intersection: Yv,
  lazy: am,
  literal: sm,
  map: tm,
  nan: Pv,
  nativeEnum: om,
  never: Gv,
  null: Zv,
  nullable: lm,
  number: Ga,
  object: Kv,
  oboolean: vm,
  onumber: hm,
  optional: um,
  ostring: pm,
  pipeline: fm,
  preprocess: dm,
  promise: cm,
  record: em,
  set: rm,
  strictObject: Wv,
  string: Ba,
  symbol: Hv,
  transformer: Dn,
  tuple: Xv,
  undefined: Uv,
  union: Qv,
  unknown: Bv,
  void: zv,
  NEVER: gm,
  ZodIssueCode: d,
  quotelessJson: mv,
  ZodError: L
}), S = (e) => e, ym = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let s = n.data;
    for (let i = t + 1; i <= this.latestVersion; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function it(e) {
  return new ym(e.versionMap, e.latestVersion, e.getVersion);
}
function Mt(e) {
  return a.custom((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
var _m = "__lodash_hash_undefined__";
function bm(e) {
  return this.__data__.set(e, _m), this;
}
var Tm = bm;
function $m(e) {
  return this.__data__.has(e);
}
var Am = $m, Sm = ma, Em = Tm, wm = Am;
function Nt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Sm(); ++t < r; )
    this.add(e[t]);
}
Nt.prototype.add = Nt.prototype.push = Em;
Nt.prototype.has = wm;
var xm = Nt;
function km(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Rm = km;
function jm(e, t) {
  return e.has(t);
}
var Cm = jm, Om = xm, Im = Rm, Mm = Cm, Nm = 1, Vm = 2;
function Pm(e, t, r, n, s, i) {
  var o = r & Nm, c = e.length, u = t.length;
  if (c != u && !(o && u > c))
    return !1;
  var l = i.get(e), f = i.get(t);
  if (l && f)
    return l == t && f == e;
  var _ = -1, A = !0, j = r & Vm ? new Om() : void 0;
  for (i.set(e, t), i.set(t, e); ++_ < c; ) {
    var M = e[_], D = t[_];
    if (n)
      var O = o ? n(D, M, _, t, e, i) : n(M, D, _, e, t, i);
    if (O !== void 0) {
      if (O)
        continue;
      A = !1;
      break;
    }
    if (j) {
      if (!Im(t, function(V, le) {
        if (!Mm(j, le) && (M === V || s(M, V, r, n, i)))
          return j.push(le);
      })) {
        A = !1;
        break;
      }
    } else if (!(M === D || s(M, D, r, n, i))) {
      A = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), A;
}
var Fa = Pm;
function Dm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, s) {
    r[++t] = [s, n];
  }), r;
}
var Lm = Dm;
function Hm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Um = Hm, Ln = Ut, Hn = Ia, Zm = Rr, qm = Fa, Bm = Lm, Gm = Um, zm = 1, Fm = 2, Km = "[object Boolean]", Wm = "[object Date]", Qm = "[object Error]", Jm = "[object Map]", Ym = "[object Number]", Xm = "[object RegExp]", eg = "[object Set]", tg = "[object String]", rg = "[object Symbol]", ng = "[object ArrayBuffer]", ag = "[object DataView]", Un = Ln ? Ln.prototype : void 0, dr = Un ? Un.valueOf : void 0;
function sg(e, t, r, n, s, i, o) {
  switch (r) {
    case ag:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ng:
      return !(e.byteLength != t.byteLength || !i(new Hn(e), new Hn(t)));
    case Km:
    case Wm:
    case Ym:
      return Zm(+e, +t);
    case Qm:
      return e.name == t.name && e.message == t.message;
    case Xm:
    case tg:
      return e == t + "";
    case Jm:
      var c = Bm;
    case eg:
      var u = n & zm;
      if (c || (c = Gm), e.size != t.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= Fm, o.set(e, t);
      var f = qm(c(e), c(t), n, s, i, o);
      return o.delete(e), f;
    case rg:
      if (dr)
        return dr.call(e) == dr.call(t);
  }
  return !1;
}
var ig = sg, Zn = Ca, og = 1, cg = Object.prototype, ug = cg.hasOwnProperty;
function lg(e, t, r, n, s, i) {
  var o = r & og, c = Zn(e), u = c.length, l = Zn(t), f = l.length;
  if (u != f && !o)
    return !1;
  for (var _ = u; _--; ) {
    var A = c[_];
    if (!(o ? A in t : ug.call(t, A)))
      return !1;
  }
  var j = i.get(e), M = i.get(t);
  if (j && M)
    return j == t && M == e;
  var D = !0;
  i.set(e, t), i.set(t, e);
  for (var O = o; ++_ < u; ) {
    A = c[_];
    var V = e[A], le = t[A];
    if (n)
      var ln = o ? n(le, V, A, t, e, i) : n(V, le, A, e, t, i);
    if (!(ln === void 0 ? V === le || s(V, le, r, n, i) : ln)) {
      D = !1;
      break;
    }
    O || (O = A == "constructor");
  }
  if (D && !O) {
    var yt = e.constructor, _t = t.constructor;
    yt != _t && "constructor" in e && "constructor" in t && !(typeof yt == "function" && yt instanceof yt && typeof _t == "function" && _t instanceof _t) && (D = !1);
  }
  return i.delete(e), i.delete(t), D;
}
var dg = lg, fr = ga, fg = Fa, pg = ig, hg = dg, qn = Ft, Bn = zt, Gn = Cr, vg = $a, mg = 1, zn = "[object Arguments]", Fn = "[object Array]", Tt = "[object Object]", gg = Object.prototype, Kn = gg.hasOwnProperty;
function yg(e, t, r, n, s, i) {
  var o = Bn(e), c = Bn(t), u = o ? Fn : qn(e), l = c ? Fn : qn(t);
  u = u == zn ? Tt : u, l = l == zn ? Tt : l;
  var f = u == Tt, _ = l == Tt, A = u == l;
  if (A && Gn(e)) {
    if (!Gn(t))
      return !1;
    o = !0, f = !1;
  }
  if (A && !f)
    return i || (i = new fr()), o || vg(e) ? fg(e, t, r, n, s, i) : pg(e, t, u, r, n, s, i);
  if (!(r & mg)) {
    var j = f && Kn.call(e, "__wrapped__"), M = _ && Kn.call(t, "__wrapped__");
    if (j || M) {
      var D = j ? e.value() : e, O = M ? t.value() : t;
      return i || (i = new fr()), s(D, O, r, n, i);
    }
  }
  return A ? (i || (i = new fr()), hg(e, t, r, n, s, i)) : !1;
}
var _g = yg, bg = _g, Wn = Pe;
function Ka(e, t, r, n, s) {
  return e === t ? !0 : e == null || t == null || !Wn(e) && !Wn(t) ? e !== e && t !== t : bg(e, t, r, n, Ka, s);
}
var Tg = Ka, $g = Tg;
function Ag(e, t) {
  return $g(e, t);
}
var Sg = Ag;
const Eg = /* @__PURE__ */ da(Sg), wg = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), pr = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), $e = {
  equals(e, t) {
    return Eg(e, t);
  }
}, xg = a.object({
  id: a.optional(a.string()),
  // Firebase Firestore ID
  url: a.string(),
  path: a.string(),
  headers: a.array(
    a.object({
      key: a.string(),
      value: a.string(),
      active: a.boolean()
    })
  ),
  params: a.array(
    a.object({
      key: a.string(),
      value: a.string(),
      active: a.boolean()
    })
  ),
  name: a.string(),
  method: a.string(),
  preRequestScript: a.string(),
  testScript: a.string(),
  contentType: a.string(),
  body: a.string(),
  rawParams: a.optional(a.string()),
  auth: a.optional(a.string()),
  httpUser: a.optional(a.string()),
  httpPassword: a.optional(a.string()),
  bearerToken: a.optional(a.string())
}), Qn = S({
  initial: !0,
  schema: xg
}), Hr = a.object({
  key: a.string(),
  active: a.boolean()
}).and(
  a.union([
    a.object({
      isFile: a.literal(!0),
      value: a.array(a.instanceof(Blob).nullable())
    }),
    a.object({
      isFile: a.literal(!1),
      value: a.string()
    })
  ])
);
a.object({
  contentType: a.literal("multipart/form-data"),
  body: a.array(Hr)
});
const kg = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(Hr).catch([])
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), ae = a.object({
  authType: a.literal("none")
}), se = a.object({
  authType: a.literal("basic"),
  username: a.string().catch(""),
  password: a.string().catch("")
}), ie = a.object({
  authType: a.literal("bearer"),
  token: a.string().catch("")
}), Rg = a.object({
  authType: a.literal("oauth-2"),
  token: a.string().catch(""),
  oidcDiscoveryURL: a.string().catch(""),
  authURL: a.string().catch(""),
  accessTokenURL: a.string().catch(""),
  clientID: a.string().catch(""),
  scope: a.string().catch("")
}), Ur = a.object({
  authType: a.literal("api-key"),
  key: a.string().catch(""),
  value: a.string().catch(""),
  addTo: a.string().catch("Headers")
}), oe = a.object({
  authType: a.literal("inherit")
}), jg = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Rg,
  Ur
]).and(
  a.object({
    authActive: a.boolean()
  })
), Cg = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), Wa = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), Qa = a.object({
  v: a.literal("1"),
  id: a.optional(a.string()),
  // Firebase Firestore ID
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  params: Cg,
  headers: Wa,
  preRequestScript: a.string().catch(""),
  testScript: a.string().catch(""),
  auth: jg,
  body: kg
});
function Og(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function Ig(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const Mg = S({
  initial: !1,
  schema: Qa,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: s,
      name: i,
      method: o,
      preRequestScript: c,
      testScript: u
    } = e, l = `${t}${r}`, f = Og(e), _ = Ig(e), A = {
      v: "1",
      endpoint: l,
      headers: n,
      params: s,
      name: i,
      method: o,
      preRequestScript: c,
      testScript: u,
      body: f,
      auth: _
    };
    return e.id && (A.id = e.id), A;
  }
}), Wt = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), Ja = Qa.extend({
  v: a.literal("2"),
  requestVariables: Wt
}), Ng = S({
  initial: !1,
  schema: Ja,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Ya = a.object({
  grantType: a.literal("AUTHORIZATION_CODE"),
  authEndpoint: a.string().trim(),
  tokenEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch(""),
  isPKCE: a.boolean(),
  codeVerifierMethod: a.union([a.literal("plain"), a.literal("S256")]).optional()
}), Qt = a.object({
  grantType: a.literal("CLIENT_CREDENTIALS"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch("")
}), Jt = a.object({
  grantType: a.literal("PASSWORD"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  username: a.string().trim(),
  password: a.string().trim(),
  token: a.string().catch("")
}), ot = a.object({
  grantType: a.literal("IMPLICIT"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch("")
}), Yt = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Ya,
    Qt,
    Jt,
    ot
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Vg = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Yt,
  Ur
]).and(
  a.object({
    authActive: a.boolean()
  })
), Xa = Ja.extend({
  v: a.literal("3"),
  auth: Vg
}), Pg = S({
  initial: !1,
  schema: Xa,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: s, authURL: i } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: i,
            tokenEndpoint: r,
            clientID: s,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Le = Ur.extend({
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Dg = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Yt,
  Le
]).and(
  a.object({
    authActive: a.boolean()
  })
), es = Xa.extend({
  v: a.literal("4"),
  auth: Dg
}), Lg = S({
  schema: es,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), ts = Ya.extend({
  clientSecret: a.string().optional()
}), Xt = Yt.extend({
  grantTypeInfo: a.discriminatedUnion("grantType", [
    ts,
    Qt,
    Jt,
    ot
  ])
}), rs = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Xt,
  Le
]).and(
  a.object({
    authActive: a.boolean()
  })
), ns = es.extend({
  v: a.literal("5"),
  auth: rs
}), Hg = S({
  schema: ns,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), as = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(Hr).catch([])
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("text/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), ss = ns.extend({
  v: a.literal("6"),
  body: as
}), Ug = S({
  schema: ss,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), Zr = ts.extend({
  refreshToken: a.string().optional()
}), is = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Zr,
    Qt,
    Jt,
    ot
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), er = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0),
    description: a.string().catch("")
  })
), ct = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0),
    description: a.string().catch("")
  })
), ut = a.object({
  authType: a.literal("aws-signature"),
  accessKey: a.string().catch(""),
  secretKey: a.string().catch(""),
  region: a.string().catch(""),
  serviceName: a.string().catch(""),
  serviceToken: a.string().optional(),
  signature: a.object({}).optional(),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), os = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  is,
  Le,
  ut
]).and(
  a.object({
    authActive: a.boolean()
  })
), cs = ss.extend({
  v: a.literal("7"),
  params: er,
  headers: ct,
  auth: os
}), Zg = S({
  schema: cs,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), qg = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, us = Qt.extend({
  clientSecret: a.string().optional()
}), ls = Jt.extend({
  clientSecret: a.string().optional()
}), Bg = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Zr,
    us,
    ls,
    ot
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), qr = a.object({
  authType: a.literal("digest"),
  username: a.string().catch(""),
  password: a.string().catch(""),
  realm: a.string().catch(""),
  nonce: a.string().catch(""),
  algorithm: a.enum(["MD5", "MD5-sess"]).catch("MD5"),
  qop: a.enum(["auth", "auth-int"]).catch("auth"),
  nc: a.string().catch(""),
  cnonce: a.string().catch(""),
  opaque: a.string().catch(""),
  disableRetry: a.boolean().catch(!1)
}), tr = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Bg,
  Le,
  ut,
  qr
]).and(
  a.object({
    authActive: a.boolean()
  })
), ds = a.union(
  Object.keys(qg).map((e) => a.literal(parseInt(e)))
), fs = a.array(
  a.object({
    key: a.string(),
    value: a.string()
  })
), Gg = a.object({
  v: a.literal("1"),
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  headers: ct,
  params: er,
  body: as,
  auth: tr,
  requestVariables: Wt
}), zg = a.object({
  name: a.string(),
  originalRequest: Gg,
  status: a.string(),
  code: a.optional(ds),
  headers: fs,
  body: a.string()
}), Fg = a.record(
  a.string(),
  zg
), ps = cs.extend({
  v: a.literal("8"),
  auth: tr,
  responses: Fg
}), Kg = S({
  schema: ps,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), hs = a.object({
  key: a.string(),
  active: a.boolean(),
  contentType: a.string().optional().catch(void 0)
}).and(
  a.union([
    a.object({
      isFile: a.literal(!0),
      value: a.array(a.instanceof(Blob).nullable()).catch([])
    }),
    a.object({
      isFile: a.literal(!1),
      value: a.string()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), vs = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(hs).catch([]),
    showIndividualContentType: a.boolean().optional().catch(!1)
  }),
  a.object({
    contentType: a.literal("application/octet-stream"),
    body: a.instanceof(File).nullable().catch(null)
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("text/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("binary"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), ms = a.object({
  v: a.literal("2"),
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  headers: ct,
  params: er,
  body: vs,
  auth: tr,
  requestVariables: Wt
}), gs = a.object({
  name: a.string(),
  originalRequest: ms,
  status: a.string(),
  code: a.optional(ds),
  headers: fs,
  body: a.string()
}), Wg = a.record(
  a.string(),
  gs
), ys = ps.extend({
  v: a.literal("9"),
  body: vs,
  responses: Wg
}), Qg = S({
  schema: ys,
  initial: !1,
  up(e) {
    const t = Object.fromEntries(
      Object.entries(e.responses).map(([r, n]) => [
        r,
        {
          ...n,
          originalRequest: {
            ...n.originalRequest,
            v: "2"
          }
        }
      ])
    );
    return {
      ...e,
      v: "9",
      responses: t
    };
  }
}), Br = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(hs).catch([]),
    showIndividualContentType: a.boolean().optional().catch(!1),
    isBulkEditing: a.boolean().optional().catch(!1)
  }),
  a.object({
    contentType: a.literal("application/octet-stream"),
    body: a.instanceof(File).nullable().catch(null)
  }),
  a.object({
    contentType: a.literal("application/x-www-form-urlencoded"),
    body: a.string().catch(""),
    isBulkEditing: a.boolean().optional().catch(!1)
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("text/xml"),
      a.literal("binary"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), _s = ys.extend({
  v: a.literal("10"),
  body: Br
}), Jg = S({
  schema: _s,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), Yg = us.extend({
  clientAuthentication: a.enum(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Gr = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Zr,
    Yg,
    ls,
    ot
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), rr = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Gr,
  Le,
  ut,
  qr
]).and(
  a.object({
    authActive: a.boolean()
  })
), Xg = ms.extend({
  v: a.literal("3"),
  auth: rr,
  body: Br
}), ey = gs.extend({
  originalRequest: Xg
}), bs = a.record(
  a.string(),
  ey
), Ts = _s.extend({
  v: a.literal("11"),
  auth: rr,
  responses: bs
}), ty = S({
  schema: Ts,
  initial: !1,
  up(e) {
    const t = e.auth, r = Object.fromEntries(
      Object.entries(e.responses).map(([n, s]) => [
        n,
        {
          ...s,
          originalRequest: {
            ...s.originalRequest,
            auth: t.authType === "oauth-2" ? {
              ...t,
              grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
                ...t.grantTypeInfo,
                clientAuthentication: "IN_BODY"
              } : t.grantTypeInfo
            } : t,
            // just following the previous pattern here, but is this a good idea to overwrite the request version ?
            v: "3"
          }
        }
      ])
    );
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t,
      responses: r
    };
  }
}), ry = a.object({
  authType: a.literal("hawk"),
  authId: a.string().catch(""),
  authKey: a.string().catch(""),
  algorithm: a.enum(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: a.boolean().catch(!1),
  // Optional fields
  user: a.string().optional(),
  nonce: a.string().optional(),
  ext: a.string().optional(),
  app: a.string().optional(),
  dlg: a.string().optional(),
  timestamp: a.string().optional()
}), ny = a.object({
  authType: a.literal("akamai-eg"),
  accessToken: a.string().catch(""),
  clientToken: a.string().catch(""),
  clientSecret: a.string().catch(""),
  // Optional fields
  nonce: a.string().optional(),
  timestamp: a.string().optional(),
  host: a.string().optional(),
  headersToSign: a.string().optional(),
  maxBodySize: a.string().optional()
}), $s = a.discriminatedUnion("authType", [
  ae,
  oe,
  se,
  ie,
  Gr,
  Le,
  ut,
  qr,
  ry,
  ny
]).and(
  a.object({
    authActive: a.boolean()
  })
), ay = Ts.extend({
  v: a.literal("12"),
  auth: $s
}), sy = S({
  schema: ay,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), iy = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, vb = Object.keys(
  iy
), oy = a.object({
  // v is a stringified number
  v: a.string().regex(/^\d+$/).transform(Number)
}), nr = it({
  latestVersion: 12,
  versionMap: {
    0: Qn,
    1: Mg,
    2: Ng,
    3: Pg,
    4: Lg,
    5: Hg,
    6: Ug,
    7: Zg,
    8: Kg,
    9: Qg,
    10: Jg,
    11: ty,
    12: sy
  },
  getVersion(e) {
    const t = oy.safeParse(e);
    return t.success ? t.data.v : Qn.schema.safeParse(e).success ? 0 : null;
  }
}), cy = Ai({
  id: wg(Q),
  v: Q,
  auth: $e,
  body: $e,
  endpoint: Q,
  headers: pr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    $e
  ),
  params: pr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    $e
  ),
  method: Q,
  name: Q,
  preRequestScript: Q,
  testScript: Q,
  requestVariables: pr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    $e
  ),
  responses: $e
}), As = "12", mb = cy.equals;
function gb(e, t) {
  const r = vv(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Br.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = rr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = er.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = ct.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Wt.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = bs.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function yb(e) {
  return {
    v: As,
    ...e
  };
}
function uy() {
  return {
    v: As,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {}
  };
}
function _b(e) {
  return nr.isLatest(e);
}
function ly(e) {
  const t = nr.safeParse(e);
  return t.type === "ok" ? t.value : uy();
}
const zr = a.object({
  key: a.string().catch(""),
  value: a.string().catch(""),
  active: a.boolean().catch(!0)
}), dy = a.object({
  v: a.literal(1),
  name: a.string(),
  url: a.string(),
  headers: a.array(zr).catch([]),
  query: a.string(),
  variables: a.string()
}), fy = S({
  initial: !0,
  schema: dy
}), me = a.object({
  authType: a.literal("none")
}), ge = a.object({
  authType: a.literal("basic"),
  username: a.string().catch(""),
  password: a.string().catch("")
}), ye = a.object({
  authType: a.literal("bearer"),
  token: a.string().catch("")
}), py = a.object({
  authType: a.literal("oauth-2"),
  token: a.string().catch(""),
  oidcDiscoveryURL: a.string().catch(""),
  authURL: a.string().catch(""),
  accessTokenURL: a.string().catch(""),
  clientID: a.string().catch(""),
  scope: a.string().catch("")
}), Fr = a.object({
  authType: a.literal("api-key"),
  key: a.string().catch(""),
  value: a.string().catch(""),
  addTo: a.string().catch("Headers")
}), _e = a.object({
  authType: a.literal("inherit")
}), hy = a.discriminatedUnion("authType", [
  me,
  ge,
  ye,
  py,
  Fr,
  _e
]).and(
  a.object({
    authActive: a.boolean()
  })
), Ss = a.object({
  id: a.optional(a.string()),
  v: a.literal(2),
  name: a.string(),
  url: a.string(),
  headers: a.array(zr).catch([]),
  query: a.string(),
  variables: a.string(),
  auth: hy
}), vy = S({
  initial: !1,
  schema: Ss,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), my = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  Fr,
  Yt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), Es = Ss.extend({
  v: a.literal(3),
  auth: my
}), gy = S({
  initial: !1,
  schema: Es,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: s, authURL: i } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: i,
            tokenEndpoint: r,
            clientID: s,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), lt = Fr.extend({
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), yy = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  lt,
  Xt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), ws = Es.extend({
  v: a.literal(4),
  auth: yy
}), _y = S({
  initial: !1,
  schema: ws,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), xs = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  lt,
  Xt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), ks = ws.extend({
  v: a.literal(5),
  auth: xs
}), by = S({
  initial: !1,
  schema: ks,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Kr = ut, Rs = a.object({
  key: a.string().catch(""),
  value: a.string().catch(""),
  active: a.boolean().catch(!0),
  description: a.string().catch("")
}), js = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  Xt,
  lt,
  Kr
]).and(
  a.object({
    authActive: a.boolean()
  })
), Cs = ks.extend({
  v: a.literal(6),
  auth: js,
  headers: a.array(Rs).catch([])
}), Ty = S({
  schema: Cs,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), Os = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  is,
  lt,
  Kr
]).and(
  a.object({
    authActive: a.boolean()
  })
), Is = Cs.extend({
  v: a.literal(7),
  auth: Os
}), $y = S({
  schema: Is,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Wr = a.discriminatedUnion("authType", [
  me,
  _e,
  ge,
  ye,
  Gr,
  lt,
  Kr
]).and(
  a.object({
    authActive: a.boolean()
  })
), Ay = Is.extend({
  v: a.literal(8),
  auth: Wr
}), Sy = S({
  schema: Ay,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Ms = 8, Ey = a.object({
  v: a.number()
}), Qr = it({
  latestVersion: 8,
  versionMap: {
    1: fy,
    2: vy,
    3: gy,
    4: _y,
    5: by,
    6: Ty,
    7: $y,
    8: Sy
  },
  getVersion(e) {
    const t = Ey.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), wy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function xy() {
  return {
    v: Ms,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: wy,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function ky(e) {
  const t = Qr.safeParse(e);
  return t.type === "ok" ? t.value : xy();
}
function bb(e) {
  return {
    v: Ms,
    ...e
  };
}
const Ry = a.object({
  v: a.literal(1),
  id: a.optional(a.string()),
  // For Firestore ID data
  name: a.string(),
  requests: a.array(
    a.lazy(
      () => a.union([
        Mt(nr),
        Mt(Qr)
      ])
    )
  )
}), Ns = Ry.extend({
  folders: a.lazy(() => a.array(Ns))
}), Jn = S({
  initial: !0,
  schema: Ns
}), Vs = a.object({
  v: a.literal(2),
  id: a.optional(a.string()),
  // For Firestore ID data
  name: a.string(),
  requests: a.array(
    a.lazy(
      () => a.union([
        Mt(nr),
        Mt(Qr)
      ])
    )
  ),
  auth: a.union([rs, xs]),
  headers: a.union([Wa, a.array(zr)])
}), Ps = Vs.extend({
  folders: a.lazy(() => a.array(Ps))
}), jy = S({
  initial: !1,
  schema: Ps,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: []
    };
    return e.id && (t.id = e.id), t;
  }
}), Ds = Vs.extend({
  v: a.literal(3),
  // AWS Signature Authorization type addition
  auth: a.union([os, js]),
  // `description` field addition under `headers`
  headers: a.union([ct, a.array(Rs)])
}), Ls = Ds.extend({
  folders: a.lazy(() => a.array(Ls))
}), Cy = S({
  initial: !1,
  schema: Ls,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t
    };
  }
}), Hs = Ds.extend({
  v: a.literal(4),
  auth: a.union([tr, Os])
}), Us = Hs.extend({
  folders: a.lazy(() => a.array(Us))
}), Oy = S({
  initial: !1,
  schema: Us,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 4
    };
  }
});
var I = [];
for (var hr = 0; hr < 256; ++hr)
  I.push((hr + 256).toString(16).slice(1));
function Iy(e, t = 0) {
  return (I[e[t + 0]] + I[e[t + 1]] + I[e[t + 2]] + I[e[t + 3]] + "-" + I[e[t + 4]] + I[e[t + 5]] + "-" + I[e[t + 6]] + I[e[t + 7]] + "-" + I[e[t + 8]] + I[e[t + 9]] + "-" + I[e[t + 10]] + I[e[t + 11]] + I[e[t + 12]] + I[e[t + 13]] + I[e[t + 14]] + I[e[t + 15]]).toLowerCase();
}
var $t, My = new Uint8Array(16);
function Ny() {
  if (!$t && ($t = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$t))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return $t(My);
}
var Vy = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Yn = {
  randomUUID: Vy
};
function Py(e, t, r) {
  if (Yn.randomUUID && !t && !e)
    return Yn.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || Ny)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Iy(n);
}
const Zs = (e = "") => {
  const t = Date.now().toString(36), r = Py();
  return `${e}_${t}_${r}`;
}, qs = Hs.extend({
  v: a.literal(5),
  _ref_id: a.string().optional()
}), Bs = qs.extend({
  folders: a.lazy(() => a.array(Bs))
}), Dy = S({
  initial: !1,
  schema: Bs,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: Zs("coll")
    };
  }
}), Gs = qs.extend({
  v: a.literal(6),
  auth: a.union([rr, Wr])
}), zs = Gs.extend({
  folders: a.lazy(() => a.array(zs))
}), Ly = S({
  initial: !1,
  schema: zs,
  // @ts-expect-error
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6
    };
  }
}), Hy = Gs.extend({
  v: a.literal(7),
  auth: a.union([$s, Wr])
}), Fs = Hy.extend({
  folders: a.lazy(() => a.array(Fs))
}), Uy = S({
  initial: !1,
  schema: Fs,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 7
    };
  }
}), Zy = a.object({
  v: a.number()
}), Tb = it({
  latestVersion: 7,
  versionMap: {
    1: Jn,
    2: jy,
    3: Cy,
    4: Oy,
    5: Dy,
    6: Ly,
    7: Uy
  },
  getVersion(e) {
    const t = Zy.safeParse(e);
    return t.success ? t.data.v : Jn.schema.safeParse(e).success ? 1 : null;
  }
}), qy = 7;
function Ks(e) {
  return {
    v: qy,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : Zs("coll")
  };
}
function By(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(By), n = (e.requests ?? []).map(ly), s = e.auth ?? { authType: "inherit", authActive: !0 }, i = e.headers ?? [], o = Ks({
    name: t,
    folders: r,
    requests: n,
    auth: s,
    headers: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
function Gy(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(Gy), n = (e.requests ?? []).map(ky), s = e.auth ?? { authType: "inherit", authActive: !0 }, i = e.headers ?? [], o = Ks({
    name: t,
    folders: r,
    requests: n,
    auth: s,
    headers: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
var ce = function(e) {
  return function(t) {
    return !e(t);
  };
}, zy = Di, Fy = Vi;
function Ws(e, t) {
  return t === void 0 ? function(r) {
    return Ws(e, r);
  } : Fy(e, t) ? oa : ca(t[e]);
}
var Qs = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, Ky = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var s = e(n, t[n]);
      ia(s) && r.push(s.value);
    }
    return r;
  };
}, Wy = function(e) {
  return Ky(function(t, r) {
    return e(r);
  });
}, Js = function(e) {
  return e.slice();
}, Qy = Ni, Xn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Jy = function(e) {
  return function(t) {
    return Xn(Xn([], t, !0), [e], !1);
  };
}, Yy = Jy, Xy = function(e) {
  return [e];
}, e_ = Yy, t_ = Ws, r_ = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, n_ = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, a_ = function() {
  return {
    concat: n_().concat,
    empty: []
  };
}, ar = oa, dt = ca;
function Ys(e) {
  return function(t) {
    return e(t) ? dt(t) : ar;
  };
}
var Sr = function(e) {
  return function(t) {
    return Xs(t) ? ar : dt(e(t.value));
  };
}, s_ = ia, Xs = function(e) {
  return e._tag === "None";
}, i_ = function(e, t) {
  return function(r) {
    return Xs(r) ? e() : t(r.value);
  };
}, o_ = i_, Jr = o_, c_ = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, ue = wi, z = xi, u_ = /* @__PURE__ */ Ti(2, function(e, t) {
  return Re(e) ? e : t(e.right);
}), ft = function(e) {
  return function(t) {
    return Re(t) ? t : z(e(t.right));
  };
}, sr = function(e) {
  return function(t) {
    return Re(t) ? ue(e(t.left)) : t;
  };
}, Re = Si, l_ = Ei, d_ = function(e) {
  return function(t) {
    return Re(t) ? e(t.left) : t.right;
  };
}, Yr = d_, ea = u_, Vt = function() {
  return Vt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Vt.apply(this, arguments);
}, pt = function(e, t, r) {
  return z({
    value: e,
    next: t,
    start: r
  });
}, ht = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), ue({
    input: e,
    expected: t,
    fatal: r
  });
}, f_ = function(e, t) {
  return Vt(Vt({}, e), { expected: t });
}, p_ = function(e, t) {
  return h_().concat(e, t);
}, h_ = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Ii().concat(e, t) : e.input.cursor > t.input.cursor ? cr().concat(e, t) : Oi({
        input: cr(),
        fatal: cr(),
        expected: a_()
      }).concat(e, t);
    }
  };
}, v_ = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, m_ = function(e) {
  return t_(e.cursor, e.buffer);
}, g_ = function(e) {
  return e.cursor >= e.buffer.length;
}, y_ = function(e) {
  return y(m_(e), Sr(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, ne = function() {
  return ne = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, ne.apply(this, arguments);
}, Xr = function(e) {
  return function(t) {
    return pt(e, t, t);
  };
}, __ = function() {
  return function(e) {
    return ht(e);
  };
}, b_ = function(e) {
  return function() {
    return ht(e);
  };
}, C = function(e) {
  return y(A_(T_()), be(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? je(r) : b_(n);
  }));
}, R = function(e, t) {
  return function(r) {
    return y(e(r), sr(function(n) {
      return f_(n, [t]);
    }));
  };
}, T_ = function() {
  return function(e) {
    return y(y_(e), Jr(function() {
      return ht(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return pt(r, n, e);
    }));
  };
}, $_ = function(e, t) {
  return function(r) {
    return y(e(r), ea(function(n) {
      return y(t(n.value)(n.next), ea(function(s) {
        return pt(s.value, s.next, r);
      }));
    }));
  };
}, ir = function(e, t) {
  return function(r) {
    var n = e(r);
    return l_(n) || n.left.fatal ? n : y(t()(r), sr(function(s) {
      return p_(n.left, s);
    }));
  };
}, A_ = function(e) {
  return function(t) {
    return y(e(t), ft(function(r) {
      return ne(ne({}, r), { value: [r.value, t] });
    }));
  };
}, ei = function(e) {
  return Te(function() {
    return je(e.empty);
  });
}, en = function() {
  return R(function(e) {
    return g_(e) ? pt(void 0, e, e) : ht(e);
  }, "end of file");
}, S_ = function(e) {
  return y(tn(e), Te(function() {
    return je([]);
  }));
}, tn = function(e) {
  return y(e, be(function(t) {
    return nn(Xy(t), function(r) {
      return y(e, k(function(n) {
        return ue(e_(n)(r));
      }), Te(function() {
        return je(z(r));
      }));
    });
  }));
}, E_ = function(e, t) {
  return function(r) {
    return y(e, be(function() {
      return r;
    }), an(function() {
      return t;
    }));
  };
}, ti = function(e) {
  return E_(e, e);
}, w_ = function(e) {
  return S_(C(ce(e)));
}, rn = function(e, t) {
  return y(t, k(function() {
    return Qy;
  }), Te(function() {
    return x_(e, t);
  }));
}, x_ = function(e, t) {
  return y(e, be(function(r) {
    return nn(Li(r), function(n) {
      return y(t, k(function() {
        return z(n);
      }), Te(function() {
        return y(e, k(function(s) {
          return ue(zy(s)(n));
        }));
      }));
    });
  }));
}, vt = function(e, t) {
  return function(r) {
    return y(e(r), ft(function(n) {
      return ne(ne({}, n), { value: t(n.value) });
    }));
  };
}, ri = function(e, t) {
  return or(e, function(r) {
    return vt(t, r);
  });
}, or = function(e, t) {
  return $_(e, t);
}, nn = function(e, t) {
  var r = function(n) {
    return function(s) {
      return Re(s.value) ? ue({ value: s.value.left, stream: s.next }) : z(pt(s.value.right, s.next, n));
    };
  };
  return function(n) {
    return c_({ value: e, stream: n }, function(s) {
      var i = t(s.value)(s.stream);
      return Re(i) ? z(ht(s.stream, i.left.expected, i.left.fatal)) : r(n)(i.right);
    });
  };
}, k_ = function(e, t) {
  return ir(e, t);
}, k = function(e) {
  return function(t) {
    return vt(t, e);
  };
}, je = Xr, be = function(e) {
  return function(t) {
    return or(t, e);
  };
}, an = function(e) {
  return function(t) {
    return or(t, function(r) {
      return vt(e(r), function() {
        return r;
      });
    });
  };
}, Te = function(e) {
  return function(t) {
    return k_(t, e);
  };
}, R_ = "Parser", j_ = function(e) {
  return {
    concat: function(t, r) {
      return ri(vt(t, function(n) {
        return function(s) {
          return e.concat(n, s);
        };
      }), r);
    }
  };
}, C_ = function(e) {
  return ne(ne({}, j_(e)), { empty: Xr(e.empty) });
}, O_ = {
  URI: R_,
  map: vt,
  ap: ri,
  chain: or,
  chainRec: nn
}, ni = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, ai = function(e) {
  return function(t) {
    return y(t, k(function(r) {
      return ni({}, e, r);
    }));
  };
}, Er = function(e, t) {
  return function(r) {
    return y(r, be(function(n) {
      return y(t(n), k(function(s) {
        return ni(n, e, s);
      }));
    }));
  };
}, I_ = function(e) {
  return Mi(e)(e.empty);
}, M_ = ei(kr), Ce = function(e) {
  return R(C(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, N_ = function(e) {
  return R(C(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, sn = function(e) {
  return M_(mt(e));
}, mt = function(e) {
  return y(tn(e), k(function(t) {
    return t.join("");
  }));
}, on = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, wr = R(C(on), "a digit"), V_ = /^\s$/, si = function(e) {
  return V_.test(e);
}, ii = R(C(si), "a whitespace"), P_ = function(e) {
  return e === "_";
}, gt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, oi = function(e) {
  return gt(e) || on(e) || P_(e);
};
R(C(oi), "a word character");
R(C(gt), "a letter");
var D_ = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
R(C(D_), "an unicode letter");
var ci = function(e) {
  return gt(e) && e === e.toUpperCase();
};
R(C(ci), "an upper case letter");
var ui = function(e) {
  return gt(e) && e === e.toLowerCase();
};
R(C(ui), "a lower case letter");
R(C(ce(on)), "a non-digit");
var li = R(C(ce(si)), "a non-whitespace character");
R(C(ce(oi)), "a non-word character");
R(C(ce(gt)), "a non-letter character");
R(C(ce(ci)), "anything but an upper case letter");
R(C(ce(ui)), "anything but a lower case letter");
var di = function(e) {
  return R(O_.chainRec(e, function(t) {
    return y(U_(0, t), Jr(function() {
      return je(z(e));
    }, function(r) {
      return y(Ce(r), be(function() {
        return je(ue(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, xr = I_(C_(kr)), nt = ei(kr), L_ = function(e) {
  return nt(H_(e));
}, H_ = function(e) {
  return y(tn(e), k(function(t) {
    return t.join("");
  }));
}, U_ = function(e, t) {
  return e < t.length ? dt(t.charAt(e)) : ar;
}, Z_ = sn(ii);
mt(ii);
sn(li);
mt(li);
var q_ = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? ar : dt(t);
};
R(y(xr([nt(Ce("-")), mt(wr)]), k(function(e) {
  return +e;
})), "an integer");
R(y(xr([nt(Ce("-")), sn(wr), nt(xr([Ce("."), mt(wr)]))]), be(function(e) {
  return y(q_(e), Jr(function() {
    return __();
  }, Xr));
})), "a float");
var B_ = ti(Ce('"'))(L_(ir(di('\\"'), function() {
  return N_('"');
})));
function fi(e) {
  return function(t) {
    return t(v_(e.split("")));
  };
}
const ta = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), G_ = ["#", ":"], Oe = ti(Z_), cn = (e) => (t) => t.join(e), un = (e) => y(
  w_((t) => e.includes(t)),
  k(cn(""))
), z_ = Y(
  un,
  an(() => C(() => !0))
), pi = y(
  B_,
  k((e) => JSON.parse(`"${e}"`))
), F_ = y(
  Oe(pi),
  Te(
    () => y(
      un([":", `
`]),
      k(ua)
    )
  )
), K_ = y(
  Oe(pi),
  Te(
    () => y(
      un([`
`]),
      k(ua)
    )
  )
), hi = y(
  nt(di("#")),
  k(ce(la))
), vi = y(
  Oe(hi),
  ai("commented"),
  Er("key", () => Oe(F_)),
  an(() => Ce(":")),
  Er("value", () => K_)
), W_ = y(
  Oe(hi),
  ai("commented"),
  Er("key", () => ir(
    z_([`
`]),
    () => y(
      rn(C((e) => !0), en()),
      k(Y(
        Js,
        cn("")
      ))
    )
  )),
  k(Y(
    Ys(({ key: e }) => !la(e))
  ))
), Q_ = y(
  rn(Oe(vi), en())
), J_ = y(
  rn(
    ir(
      y(vi, k(dt)),
      () => y(
        W_,
        k(Y(
          Sr((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    en()
  ),
  k(Y(
    Wy(Y(
      Ys(s_),
      Sr((e) => e.value)
    ))
  ))
), Y_ = (e) => {
  if (G_.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, ra = (e) => Y_(e) ? JSON.stringify(e) : e, $b = (e) => y(
  e,
  r_(
    Y(
      ta("key", ra),
      ta("value", ra),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  cn(`
`)
), X_ = (e) => y(
  J_,
  fi(e),
  sr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  ft(
    ({ value: t }) => y(
      t,
      Qs(
        ({ key: r, value: n, commented: s }) => ({
          active: !s,
          key: r,
          value: n
        })
      )
    )
  )
), Ab = (e) => y(
  Q_,
  fi(e),
  sr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  ft(
    ({ value: t }) => y(
      t,
      Qs(
        ({ key: r, value: n, commented: s }) => ({
          active: !s,
          key: r,
          value: n
        })
      )
    )
  )
), Sb = Y(
  X_,
  ft(Js),
  Yr(() => [])
), eb = a.object({
  id: a.optional(a.string()),
  name: a.string(),
  variables: a.array(
    a.object({
      key: a.string(),
      value: a.string()
    })
  )
}), na = S({
  initial: !0,
  schema: eb
}), mi = () => Math.random().toString(36).substring(2, 16), tb = a.object({
  v: a.literal(1),
  id: a.string(),
  name: a.string(),
  variables: a.array(
    a.union([
      a.object({
        key: a.string(),
        secret: a.literal(!0)
      }),
      a.object({
        key: a.string(),
        value: a.string(),
        secret: a.literal(!1).catch(!1)
      })
    ])
  )
}), rb = S({
  initial: !1,
  schema: tb,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || mi(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), gi = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], nb = a.object({
  v: a.number()
}), Eb = it({
  latestVersion: 1,
  versionMap: {
    0: na,
    1: rb
  },
  getVersion(e) {
    const t = nb.safeParse(e);
    return t.success ? t.data.v : na.schema.safeParse(e).success ? 0 : null;
  }
}), Pt = /<<([^>]*)>>/g, Dt = 10, yi = "ENV_EXPAND_LOOP", aa = 1;
function ab(e, t) {
  let r = e, n = 0;
  for (; r.match(Pt) != null && n <= Dt; )
    r = r.replace(Pt, (s) => {
      const i = s.replace(/[<>]/g, ""), o = gi.find(
        (u) => u.key === i
      );
      if (o)
        return o.getValue();
      const c = t.find((u) => u.key === i);
      return c && "value" in c ? c.value : s;
    }), n++;
  return n > Dt ? ue(yi) : z(r);
}
const wb = (e, t) => y(
  ab(e, t),
  Yr(() => e)
);
function sb(e, t, r = !1, n = !1) {
  if (!t || !e)
    return z(e);
  let s = e, i = 0, o = !1;
  for (; s.match(Pt) != null && i <= Dt && !o; )
    s = decodeURI(encodeURI(s)).replace(Pt, (c, u) => {
      const l = gi.find(
        (_) => _.key === u
      );
      if (l)
        return l.getValue();
      const f = t.find((_) => _ && _.key === u);
      return f && "value" in f ? f.secret && n ? (o = !0, `<<${u}>>`) : f.secret && r ? "*".repeat(
        f.value.length
      ) : f.value : "";
    }), i++;
  return i > Dt ? ue(yi) : z(s);
}
const xb = (e, t, r = !1, n = !1) => y(
  sb(e, t, r, n),
  Yr(() => e)
), ib = (e) => ({
  key: e.key,
  value: e.value,
  secret: !1
}), kb = (e) => {
  if (e.v && e.v === aa) return e;
  const t = e.id || mi(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(ib);
  return {
    v: aa,
    id: t,
    name: r,
    variables: n
  };
}, ob = a.array(
  a.union([
    a.object({
      key: a.string(),
      value: a.string(),
      secret: a.literal(!1)
    }),
    a.object({
      key: a.string(),
      secret: a.literal(!0)
    }),
    a.object({
      key: a.string(),
      value: a.string()
    })
  ])
), sa = S({
  initial: !0,
  schema: ob
}), cb = a.object({
  v: a.literal(1),
  variables: a.array(
    a.union([
      a.object({
        key: a.string(),
        secret: a.literal(!0)
      }),
      a.object({
        key: a.string(),
        value: a.string(),
        secret: a.literal(!1)
      })
    ])
  )
}), ub = S({
  initial: !1,
  schema: cb,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), lb = a.object({
  v: a.number()
}), Rb = it({
  latestVersion: 1,
  versionMap: {
    0: sa,
    1: ub
  },
  getVersion(e) {
    const t = lb.safeParse(e);
    return t.success ? t.data.v : sa.schema.safeParse(e).success ? 0 : null;
  }
});
async function db(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function fb(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
async function pb(e, t, r) {
  const n = new TextEncoder(), s = n.encode(e), i = n.encode(t), o = r === "sha256" ? "SHA-256" : "SHA-1", c = await crypto.subtle.importKey(
    "raw",
    s,
    {
      name: "HMAC",
      hash: { name: o }
    },
    !1,
    ["sign"]
  ), u = await crypto.subtle.sign("HMAC", c, i);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(u)]));
}
async function hb(e) {
  if (!e) return "";
  if (e instanceof FormData) {
    const t = [];
    return e.forEach((r, n) => {
      t.push(`${n}=${r}`);
    }), t.join("&");
  }
  return e instanceof File ? await e.text() : e.toString();
}
async function jb(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await db(), n = new URL(e.url), s = n.hostname, i = n.port || (n.protocol === "https:" ? "443" : "80"), o = n.pathname + n.search, c = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: o,
    host: s,
    port: i,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload) {
    const j = `hawk.1.payload
text/plain
${await hb(e.payload)}
`, M = await fb(j);
    c.hash = btoa(
      String.fromCharCode.apply(null, [...new Uint8Array(M)])
    );
  }
  const u = `hawk.1.header
${c.ts}
${c.nonce}
${c.method}
${c.resource}
${c.host}
${c.port}
${c.hash}
${c.ext}
`, l = await pb(e.key, u, e.algorithm), f = [
    `Hawk id="${e.id}"`,
    `ts="${c.ts}"`,
    `nonce="${c.nonce}"`,
    `mac="${l}"`
  ];
  return e.ext && e.ext !== "" && f.push(`ext="${e.ext}"`), e.app && e.app !== "" && f.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && f.push(`dlg="${e.dlg}"`), c.hash !== "" && f.push(`hash="${c.hash}"`), f.join(", ");
}
async function Cb(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), s = e.host || new URL(e.url).host, i = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    i,
    t.encode(r)
  );
  let o = "";
  if (e.body) {
    const _ = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    o = Array.from(new Uint8Array(_)).map((A) => A.toString(16).padStart(2, "0")).join("");
  }
  const c = `${e.method} ${e.url} ${s} ${r} ${n} ${o}`, u = await crypto.subtle.sign(
    "HMAC",
    i,
    t.encode(c)
  ), l = btoa(
    String.fromCharCode(...new Uint8Array(u))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${l}`;
}
export {
  ts as AuthCodeGrantTypeParams,
  Yg as ClientCredentialsGrantTypeParams,
  qy as CollectionSchemaVersion,
  Eb as Environment,
  aa as EnvironmentSchemaVersion,
  hs as FormDataKeyValue,
  Rs as GQLHeader,
  Ms as GQL_REQ_SCHEMA_VERSION,
  Rb as GlobalEnvironment,
  gi as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  Tb as HoppCollection,
  Wr as HoppGQLAuth,
  lt as HoppGQLAuthAPIKey,
  Kr as HoppGQLAuthAWSSignature,
  ge as HoppGQLAuthBasic,
  ye as HoppGQLAuthBearer,
  _e as HoppGQLAuthInherit,
  me as HoppGQLAuthNone,
  Gr as HoppGQLAuthOAuth2,
  Qr as HoppGQLRequest,
  $s as HoppRESTAuth,
  Le as HoppRESTAuthAPIKey,
  ut as HoppRESTAuthAWSSignature,
  ny as HoppRESTAuthAkamaiEdgeGrid,
  se as HoppRESTAuthBasic,
  ie as HoppRESTAuthBearer,
  qr as HoppRESTAuthDigest,
  ry as HoppRESTAuthHAWK,
  oe as HoppRESTAuthInherit,
  ae as HoppRESTAuthNone,
  Gr as HoppRESTAuthOAuth2,
  ct as HoppRESTHeaders,
  er as HoppRESTParams,
  Br as HoppRESTReqBody,
  nr as HoppRESTRequest,
  ey as HoppRESTRequestResponse,
  bs as HoppRESTRequestResponses,
  Wt as HoppRESTRequestVariables,
  Xg as HoppRESTResponseOriginalRequest,
  ot as ImplicitOauthFlowParams,
  ls as PasswordGrantTypeParams,
  As as RESTReqSchemaVersion,
  vb as ValidContentTypesList,
  Cb as calculateAkamaiEdgeGridHeader,
  jb as calculateHawkHeader,
  Zs as generateUniqueRefId,
  xy as getDefaultGQLRequest,
  uy as getDefaultRESTRequest,
  mb as isEqualHoppRESTRequest,
  _b as isHoppRESTRequest,
  iy as knownContentTypes,
  Ks as makeCollection,
  bb as makeGQLRequest,
  yb as makeRESTRequest,
  wb as parseBodyEnvVariables,
  ab as parseBodyEnvVariablesE,
  Sb as parseRawKeyValueEntries,
  X_ as parseRawKeyValueEntriesE,
  xb as parseTemplateString,
  sb as parseTemplateStringE,
  $b as rawKeyValueEntriesToString,
  gb as safelyExtractRESTRequest,
  Ab as strictParseRawKeyValueEntriesE,
  ky as translateToGQLRequest,
  kb as translateToNewEnvironment,
  ib as translateToNewEnvironmentVariables,
  Gy as translateToNewGQLCollection,
  By as translateToNewRESTCollection,
  ly as translateToNewRequest
};
